var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "entry-multi-tab" },
    [
      _c(
        "div",
        { staticClass: "entry-multi-tab__menus" },
        [
          _c("icon-font", {
            staticStyle: { "font-size": "14px", cursor: "pointer" },
            attrs: { type: "gb-icon-appstore" },
            on: {
              click: function($event) {
                _vm.visible = true
              }
            }
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible,
                  expression: "visible"
                }
              ],
              staticClass: "entry-multi-tab__menus__wrapper"
            },
            [
              _c(
                "div",
                { staticClass: "entry-multi-tab__menus__wrapper__main" },
                [
                  _c("div", { staticClass: "entry-menus-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "entry-menus-wrapper__hd" },
                      [
                        _c("icon-font", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { type: "gb-icon-appstore" }
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("layouts.allmenu")))]),
                        _c("icon-font", {
                          staticStyle: {
                            "font-size": "22px",
                            cursor: "pointer"
                          },
                          attrs: { type: "gb-icon-guanbi" },
                          on: {
                            click: function($event) {
                              _vm.visible = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "entry-menus-wrapper__search" },
                      [
                        _c(
                          "a-input",
                          {
                            attrs: {
                              "allow-clear": "",
                              size: "large",
                              placeholder: _vm.$t("layouts.menusearch")
                            },
                            model: {
                              value: _vm.keyword,
                              callback: function($$v) {
                                _vm.keyword = $$v
                              },
                              expression: "keyword"
                            }
                          },
                          [
                            _c("a-icon", {
                              attrs: { slot: "prefix", type: "search" },
                              slot: "prefix"
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.keyword
                      ? _c(
                          "div",
                          { staticClass: "entry-menus-wrapper__bd" },
                          [
                            _c("entry-menus-search", {
                              attrs: {
                                menus: _vm.menus,
                                favorites: _vm.favorites,
                                keyword: _vm.keyword,
                                currentLang: _vm.currentLang,
                                tabActiveKey: _vm.tabActiveKey
                              },
                              on: {
                                click: function(key) {
                                  return _vm.onChange(key, {
                                    statisticsType: 1,
                                    searchKey: _vm.keyword
                                  })
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "entry-menus-wrapper__bd" },
                          [
                            _c("menus-item", {
                              attrs: {
                                tabActiveKey: _vm.tabActiveKey,
                                currentLang: _vm.currentLang,
                                menu: _vm.menusLevel2,
                                "active-key": _vm.tabActiveKey,
                                favorites: _vm.favorites
                              },
                              on: { click: _vm.onChange }
                            })
                          ],
                          1
                        )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "entry-menus-silder" },
                [
                  _vm._l(
                    _vm.menusLevel2.childMenus.filter(function(find) {
                      return find.updateFlag === 1
                    }),
                    function(menu) {
                      return [
                        _c(
                          "div",
                          {
                            key: menu.key,
                            staticClass: "entry-menus-silder__item",
                            class: {
                              "entry-menus-silder__item--active":
                                _vm.tabActiveKey === menu.key
                            },
                            on: {
                              click: function($event) {
                                return _vm.onTabChange(menu.key)
                              }
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm._f("menuNameRender")(menu)))
                            ])
                          ]
                        )
                      ]
                    }
                  )
                ],
                2
              )
            ]
          ),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visible,
                expression: "visible"
              }
            ],
            staticClass: "entry-multi-tab__menus__mask",
            on: {
              click: function($event) {
                _vm.visible = false
              }
            }
          })
        ],
        1
      ),
      _c(
        "main",
        { staticClass: "entry-multi-tab__wrapper" },
        [
          _c(
            "a-tabs",
            {
              attrs: {
                hideAdd: "",
                type: "editable-card",
                activeKey: _vm.activeKey
              },
              on: { change: _vm.onChange, edit: _vm.onEdit }
            },
            [
              _vm._l(_vm.panes, function(pane, index) {
                return _c(
                  "a-tab-pane",
                  { key: pane.key, attrs: { closable: pane.closable } },
                  [
                    index === 0
                      ? _c("a-icon", {
                          staticStyle: { "font-size": "14px" },
                          attrs: { slot: "tab", type: "home" },
                          slot: "tab"
                        })
                      : _c("span", { attrs: { slot: "tab" }, slot: "tab" }, [
                          _vm._v(_vm._s(_vm._f("menuNameRender")(pane)))
                        ])
                  ],
                  1
                )
              }),
              _c(
                "a-dropdown",
                {
                  attrs: { slot: "tabBarExtraContent", trigger: ["click"] },
                  slot: "tabBarExtraContent"
                },
                [
                  _c(
                    "div",
                    { staticClass: "dropdown-content" },
                    [_c("a-icon", { attrs: { type: "down" } })],
                    1
                  ),
                  _c(
                    "a-menu",
                    {
                      attrs: { slot: "overlay" },
                      on: { click: _vm.closeMenuClick },
                      slot: "overlay"
                    },
                    [
                      _c("a-menu-item", { key: "ClosePane" }, [
                        _vm._v(_vm._s(_vm.$t("tabs.close.current")))
                      ]),
                      _c("a-menu-item", { key: "CloseRightPanes" }, [
                        _vm._v(_vm._s(_vm.$t("tabs.close.right")))
                      ]),
                      _c("a-menu-item", { key: "CloseLeftPanes" }, [
                        _vm._v(_vm._s(_vm.$t("tabs.close.left")))
                      ]),
                      _c("a-menu-item", { key: "CloseAllPane" }, [
                        _vm._v(_vm._s(_vm.$t("tabs.close.all")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "demo",
              rawName: "v-demo",
              value: "guideTo",
              expression: "'guideTo'"
            }
          ],
          staticClass: "entry-oguide"
        },
        [
          _c("icon-font", {
            staticStyle: { "margin-right": "5px" },
            attrs: { type: "gb-icon-helper-circle" }
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("layouts.operation.guide")))])
        ],
        1
      ),
      _c("a-popover", { attrs: { placement: "bottom" } }, [
        _c(
          "div",
          { staticClass: "entry-bookmarks" },
          [
            _c("img", {
              staticClass: "entry-bookmarks-icon",
              attrs: { src: require("@/assets/start.png") }
            }),
            _c("span", { staticClass: "entry-bookmarks-text" }, [
              _vm._v(_vm._s(_vm.$t("layouts.bookmarks")))
            ]),
            _c("a-icon", {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "caret-down" }
            })
          ],
          1
        ),
        _vm.favorites.length
          ? _c(
              "div",
              {
                staticClass: "entry-bookmarks-wrapper",
                attrs: { slot: "content" },
                slot: "content"
              },
              [
                _c(
                  "div",
                  { staticClass: "entry-bookmarks-list" },
                  _vm._l(_vm.favorites, function(item) {
                    return _c(
                      "div",
                      {
                        key: item.key,
                        staticClass: "entry-bookmarks-list__item",
                        on: {
                          click: function($event) {
                            return _vm.onChange(item.key, {
                              statisticsType: 2,
                              searchKey: ""
                            })
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "entry-bookmarks-list__thumb",
                          attrs: {
                            src: require("@/assets/bookmark.png"),
                            alt: ""
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "entry-bookmarks-list__title" },
                          [_vm._v(_vm._s(_vm._f("menuLocalName")(item)))]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "entry-bookmarks-btn",
                    on: {
                      click: function($event) {
                        _vm.visible = true
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("layouts.manageFavorites")))]
                )
              ]
            )
          : _c(
              "div",
              {
                staticClass: "entry-bookmarks-wrapper",
                attrs: { slot: "content" },
                slot: "content"
              },
              [
                _c("div", { staticClass: "entry-bookmarks-list" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#999",
                        "text-align": "center",
                        "line-height": "48px"
                      }
                    },
                    [
                      _vm._v(
                        "-- " + _vm._s(_vm.$t("layouts.text.undefined")) + " --"
                      )
                    ]
                  )
                ])
              ]
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }